var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-filters"},[_c('FilterByFaultTypes'),(_vm.companyHas('poleByFolders'))?_c('div',{attrs:{"id":"priority-filters"}},[_c('FilterByPriority')],1):_c('div',{attrs:{"id":"severity-filters"}},[_c('FilterBySeverity')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }